"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = __importDefault(require("axios"));
const auth_error_1 = __importDefault(require("./errors/auth_error"));
const storage_1 = __importDefault(require("./storage"));
const api_error_1 = __importDefault(require("./errors/api_error"));
function deprecated() {
    return function (target, propertyKey, descriptor) {
        var originalMethod = descriptor.value;
        descriptor.value = function (...args) {
            if (process.env.NODE_ENV !== 'production') {
                console.warn("This method is deprecated, check the examples in the project root on how to use this packages.");
            }
            return originalMethod.apply(this, args);
        };
        return descriptor;
    };
}
;
const DEFAULT_CONFIG = {
    baseUrl: '{{eventix-prod-api-placeholder}}',
};
// TODO: add function param validation for js bundle
class Auth {
    constructor() {
        this.isLoggedIn = false;
        // Current token
        this._token = null;
        // Intercepts 401 statuscodes to refresh the access token and retry the original request
        this._intercept401 = (error) => __awaiter(this, void 0, void 0, function* () {
            // TODO: status on null
            if (error.request && error.request.status === 401) {
                if (error.config.url.includes('/token')) {
                    if (this._config.onLogout) {
                        this._config.onLogout();
                    }
                    return Promise.reject(new api_error_1.default(error));
                }
                else {
                    // Fetch a new token
                    try {
                        const token = yield this._refreshToken();
                        this._setToken(token);
                        return yield this._axios.request(error.request);
                    }
                    catch (e) {
                        console.error(e);
                        return Promise.reject(new auth_error_1.default('Cannot update accesstoken'));
                    }
                }
            }
            else {
                return Promise.reject(new api_error_1.default(error));
            }
        });
    }
    init(config) {
        // Merge default config with given config
        this._config = Object.assign(Object.assign({}, DEFAULT_CONFIG), config);
        // Check if all values are set
        if (!this._config.clientId || !this._config.clientSecret || !this._config.baseUrl) {
            throw new auth_error_1.default('Configuration object is incomplete');
        }
        this._axios = this._config.httpClient || axios_1.default.create();
        this._tokenStorage = new storage_1.default();
        // Get token from storage
        const token = this._tokenStorage.getDefaultToken();
        if (token) {
            this._setToken(token);
        }
    }
    signup(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestData = {
                url: `${this._config.baseUrl}/signup`,
                method: 'post',
                data: Object.assign(Object.assign({}, params), { client_id: this._config.clientId }),
            };
            try {
                const response = yield this._axios.request(requestData);
                return true;
            }
            catch (error) {
                throw this.createError(error);
            }
        });
    }
    // Get validation rules for signup form
    getSignupValidationRules() {
        return __awaiter(this, void 0, void 0, function* () {
            return this._getEntity('/signup/rules', null, true);
        });
    }
    // Login the user and store the access token to TokenService.
    login(username, password) {
        return __awaiter(this, void 0, void 0, function* () {
            const requestData = {
                url: `${this._config.baseUrl}/token`,
                method: 'post',
                data: {
                    grant_type: 'password',
                    username,
                    password,
                    client_id: this._config.clientId,
                    client_secret: this._config.clientSecret,
                },
            };
            try {
                const response = yield this._axios.request(requestData);
                this._tokenStorage.removeAllTokens();
                const token = this._tokenFromJson(response.data);
                this._setToken(token);
                this._tokenStorage.setFallbackToken(token.company_id);
                return true;
            }
            catch (error) {
                throw this.createError(error);
            }
        });
    }
    getUser() {
        return __awaiter(this, void 0, void 0, function* () {
            return this._getEntity('/user/me');
        });
    }
    getCompany() {
        return __awaiter(this, void 0, void 0, function* () {
            return this._getEntity('/company/me');
        });
    }
    getWhitelabel() {
        return __awaiter(this, void 0, void 0, function* () {
            return this._getEntity('/whitelabel/me');
        });
    }
    getMe() {
        return __awaiter(this, void 0, void 0, function* () {
            return this._getEntity('/me');
        });
    }
    getCompanies(page) {
        return __awaiter(this, void 0, void 0, function* () {
            return this._getEntity('/switch', { page });
        });
    }
    get currentCompanyGuid() {
        var _a;
        return (_a = this._token) === null || _a === void 0 ? void 0 : _a.company_id;
    }
    switchCompany(company_id) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this._token) {
                throw new auth_error_1.default('Cannot switch companies: current token is null');
            }
            // Cannot switch to current company
            if (company_id === this._token.company_id) {
                throw new auth_error_1.default('Cannot switch to current company');
            }
            const token = this._tokenStorage.getTokenForCompany(company_id);
            const timestamp = Math.round(Date.now() / 1000);
            if (token && token.expiry_date > timestamp) {
                this._setToken(token);
                return true;
            }
            const fallback = this._tokenStorage.getFallbackToken();
            if (!fallback || fallback.expiry_date < timestamp) {
                return false;
            }
            const requestData = {
                url: `${this._config.baseUrl}/token`,
                method: 'post',
                data: {
                    grant_type: 'company_switch',
                    client_id: this._config.clientId,
                    client_secret: this._config.clientSecret,
                    access_token: fallback.access_token,
                    company_id,
                },
            };
            try {
                const response = yield this._axios.request(requestData);
                // Create a token object from the API response
                const token = this._tokenFromJson(response.data);
                // Set as the default token
                this._setToken(token);
                return true;
            }
            catch (error) {
                throw this.createError(error);
            }
        });
    }
    // Logout the current user by removing the token from storage.
    logout() {
        // Remove Authorization header from the client
        this._removeAllTokens();
        this.isLoggedIn = false;
        if (this._config.onLogout) {
            this._config.onLogout();
        }
    }
    request(config) {
        return __awaiter(this, void 0, void 0, function* () {
            // TODO: domain check
            return this._axios(config);
        });
    }
    setCustomHeader(key, value) {
        this._axios.defaults.headers.common[key] = value;
    }
    /* START OLD DASHBOARD SUPPORT FUNCTIONS */
    refreshToken() {
        return __awaiter(this, void 0, void 0, function* () {
            // Get the refresh token
            const token = yield this._refreshToken();
            // Save it to storage
            this._setToken(token);
        });
    }
    getAccessToken() {
        return this._token;
    }
    /* END OLD DASHBOARD SUPPORT FUNCTIONS */
    _getEntity(path, params, unauthenticated) {
        return __awaiter(this, void 0, void 0, function* () {
            // Check if logged in
            if (!this.isLoggedIn && !unauthenticated) {
                throw Error('Login to perform authenticated requests');
            }
            const requestData = {
                url: `${this._config.baseUrl}${path}`,
                method: 'get',
                params,
            };
            try {
                const response = yield this._axios.request(requestData);
                return response.data;
            }
            catch (e) {
                throw new api_error_1.default(e);
            }
        });
    }
    // Refresh the access token.
    _refreshToken() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this._token) {
                throw new auth_error_1.default('Cannot refresh token: current token is null');
            }
            // TODO: prevent multiple concurrent calls
            const requestData = {
                url: `${this._config.baseUrl}/token`,
                method: 'post',
                data: {
                    grant_type: 'refresh_token',
                    refresh_token: this._token.refresh_token,
                    client_id: this._config.clientId,
                    client_secret: this._config.clientSecret,
                },
            };
            try {
                return this._axios.request(requestData);
            }
            catch (error) {
                throw this.createError(error);
            }
        });
    }
    // Set a new authorization token for the API
    _setToken(token) {
        if (!token) {
            throw new auth_error_1.default('Cannot set authorization token: is null or undefined');
        }
        this._token = token;
        this._setAuthorizationHeader(token);
        this._mount401Interceptor();
        this._tokenStorage.setTokenForCompany(token);
        this.isLoggedIn = true;
    }
    // Remove the current authorization token
    _removeAllTokens() {
        this.isLoggedIn = false;
        this._removeAuthorizationHeader();
        this._unmount401Interceptor();
        if (this._token) {
            this._tokenStorage.removeAllTokens();
            this._token = null;
        }
    }
    // Add the 401 interceptor to axios
    _mount401Interceptor() {
        this._interceptorID = this._axios.interceptors.response.use((response) => response, this._intercept401);
    }
    // Remove the 401 interceptor from axios
    _unmount401Interceptor() {
        if (this._interceptorID) {
            this._axios.interceptors.response.eject(this._interceptorID);
        }
    }
    // Add the Authorization header to the axios instance
    _setAuthorizationHeader(token) {
        this._axios.defaults.headers.common.Authorization = `Bearer ${token.access_token}`;
    }
    // Remove the Authorization header from the axios instance
    _removeAuthorizationHeader() {
        delete this._axios.defaults.headers.common.Authorization;
    }
    _tokenFromJson(rawToken) {
        const timestamp = Math.round(new Date().getTime() / 1000);
        return {
            company_id: rawToken.info.company.guid,
            whitelabel_id: rawToken.info.whitelabel.guid,
            access_token: rawToken.access_token,
            refresh_token: rawToken.refresh_token,
            expiry_date: timestamp + rawToken.expires_in,
            refresh_token_expiry_date: timestamp + rawToken.refresh_token_expires_in,
        };
    }
    createError(error) {
        if (error.isAxiosError) {
            return new api_error_1.default(error);
        }
        else if (error instanceof api_error_1.default) {
            return error;
        }
        else {
            return new auth_error_1.default(error.message);
        }
    }
}
__decorate([
    deprecated()
], Auth.prototype, "refreshToken", null);
__decorate([
    deprecated()
], Auth.prototype, "getAccessToken", null);
exports.default = Auth;
//# sourceMappingURL=auth.js.map